"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _checkbox = _interopRequireDefault(require("../checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var labelStyles = {
  color: "body-grey",
  fontSize: 2,
  letterSpacing: "0.5px",
  px: 2,
  py: "10px",
  width: 1
};
var ItemBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "list-select__ItemBox",
  componentId: "sc-cpcx1e-0"
})(["&:focus{outline:none;}&:hover,&:focus{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme && theme.breakpointInts && (0, _styledComponents.css)(["@media (min-width:", "px){background-color:", ";}"], theme.breakpointInts[1], (0, _styles.colors)("background-ultra-light", {
    theme: theme
  }));
});
var listStyles = {
  cursor: "pointer",
  pl: 2,
  position: "relative",
  pr: "10px",
  py: "10px"
};
var propTypes = {
  /** list click handler */
  itemClickHandler: _propTypes.func,

  /**  array of items */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),

  /**  search query string */
  searchQuery: _propTypes.string,

  /**  array of selected items */
  selectedItems: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),

  /** selection count callback handler */
  selectionCountHandler: _propTypes.func,

  /** show list of items */
  show: _propTypes.bool
};

var ListSelect = function ListSelect(_ref2) {
  var _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      itemClickHandler = _ref2.itemClickHandler,
      selectionCountHandler = _ref2.selectionCountHandler,
      searchQuery = _ref2.searchQuery,
      selectedItems = _ref2.selectedItems,
      show = _ref2.show;

  var _useState = (0, _react.useState)([]),
      uncheckedArray = _useState[0],
      setUnchecked = _useState[1];

  var _useState2 = (0, _react.useState)(selectedItems),
      checkedArray = _useState2[0],
      setChecked = _useState2[1];
  /**
   * Handle selected list click
   */


  var toggleChecked = (0, _react.useCallback)(function (checkboxIndex) {
    setChecked(checkedArray.filter(function (item, index) {
      return index !== checkboxIndex;
    }));
    setUnchecked(uncheckedArray.concat(checkedArray[checkboxIndex]).filter(function (s) {
      return s.label.indexOf(searchQuery) > -1;
    }).sort(function (a, b) {
      return a.label > b.label ? 1 : -1;
    }));
  }, [checkedArray, searchQuery, uncheckedArray]);
  /**
   * Handle unselected list click
   */

  var toggleUnchecked = (0, _react.useCallback)(function (checkboxIndex) {
    setUnchecked(uncheckedArray.filter(function (index) {
      return index !== checkboxIndex;
    }).sort(function (a, b) {
      return a.label > b.label ? 1 : -1;
    }));
    setChecked(checkedArray.concat(uncheckedArray[checkboxIndex]));
  }, [checkedArray, uncheckedArray]);
  /**
   * Highlight search text
   */

  var regex = (0, _react.useMemo)(function () {
    return new RegExp("(" + searchQuery + ")(?![^<]*>)", "gi");
  }, [searchQuery]);
  var highlight = (0, _react.useCallback)(function (highlightText) {
    return highlightText && searchQuery ? highlightText.replace(regex, function (match) {
      return "<mark style=\"background:inherit;color:#222222;\">" + match + "</mark>";
    }) : highlightText;
  }, [regex, searchQuery]);
  /**
   * Filter Array by search query and sort it
   */

  (0, _react.useEffect)(function () {
    setUnchecked(items.filter(function (s) {
      return s.label.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;
    }).filter(function (s) {
      return !checkedArray.some(function (item) {
        return item.label === s.label;
      });
    }).sort(function (a, b) {
      return a.label > b.label ? 1 : -1;
    }));
    selectionCountHandler(checkedArray.length);
  }, [items, checkedArray, searchQuery, selectionCountHandler]);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: "column",
    minWidth: 244,
    position: "relative",
    width: 1
  }, checkedArray.length || uncheckedArray.length ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _utils.mapIndexed)(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(ItemBox, _extends({
      key: item.id,
      onClick: function onClick(event) {
        toggleChecked(index);
        itemClickHandler(Object.assign({
          event: event
        }, item));
        event.stopPropagation();
      },
      role: "menuitem",
      tabIndex: "-1"
    }, listStyles), /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
      disabled: false,
      display: "flex",
      flexDirection: "row-reverse",
      indeterminate: false,
      isChecked: true,
      label: searchQuery ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].RawHtml, {
        html: highlight(item.label),
        tag: "span"
      }) : item.label,
      searchQuery: searchQuery
    }));
  }, checkedArray), show && (0, _utils.mapIndexed)(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(ItemBox, _extends({
      key: item.id,
      onClick: function onClick(event) {
        toggleUnchecked(index);
        itemClickHandler(Object.assign({
          event: event
        }, item));
        event.stopPropagation();
      },
      role: "menuitem",
      tabIndex: "-1"
    }, listStyles), /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
      disabled: false,
      display: "flex",
      flexDirection: "row-reverse",
      indeterminate: false,
      isChecked: false,
      label: searchQuery ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].RawHtml, {
        html: highlight(item.label),
        tag: "span"
      }) : item.label,
      searchQuery: searchQuery
    }));
  }, uncheckedArray)) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, labelStyles, "No Results Found"));
};

ListSelect.propTypes = propTypes;
var _default = ListSelect;
exports["default"] = _default;